import Translation from '../../Translation/cont/Translation'
import OverlayWrapper from './OverlayWrapper'

const OverlayNonSiOhhh = ({titleTransId, text, nonButtonTextTransId, nonOnClickButton, siButtonTextTransId, siOnClickButton}) => (
    <OverlayWrapper>
        <div className='title-large-color text'><Translation id={titleTransId}/></div>
        <p className="text-large-light text">{text}</p>
        <div className="cancel-button-wrapper">
            <button className="button-cancel" onClick={()=>nonOnClickButton()}><span className=''><Translation id={nonButtonTextTransId}/></span></button>
        </div>
        <div className="save-button-wrapper">
            <button className="button-save" onClick={()=>siOnClickButton()}><span className=''><Translation id={siButtonTextTransId}/></span></button>
        </div>
    </OverlayWrapper>
)

export default OverlayNonSiOhhh